import { Link } from "react-router-dom";
import VcfImportFlow from "../components/VcfImportFlow";

export default function ImportVcfPage() {
  return (
    <main className="min-h-screen bg-washi px-6 py-10">
      <div className="mx-auto max-w-4xl">
        <Link to="/cards" className="text-sm text-navySoft hover:underline">
          ← 一覧に戻る
        </Link>
        <h2 className="serif mt-4 text-2xl font-medium text-navy">
          VCF インポート
        </h2>
        <p className="mt-2 mb-8 text-sm text-navySoft">
          iOS 連絡先 / Google Contacts / LINE myBridge / Outlook で書き出した
          .vcf ファイルを読み込み、Google Sheets に追加します。氏名・会社・電話・メール・住所などを自動で抽出します。
        </p>

        <VcfImportFlow />
      </div>
    </main>
  );
}
